import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../../store/global-selectors';

import { DropdownMenuItemWithNestedMenu } from 'ui-components/components/dropdown-menu-item-with-nested-menu';

import { buildShipmentManifestData } from '../../../../../containers/print-document-button-containers/order-details/helper/build-shipment-manifest-data';
import { CustomsForm } from '../../../../../containers/print-document-button-containers/order-details/components/customs-form';
import { Label } from '../../../../../containers/print-document-button-containers/order-details/components/label';
import {
  ORDER_DETAILS_ACTIONS,
  useTrackOrderDetailsAction,
} from '../../../../../orders/modals/order-details-modal/event-tracking/use-track-order-details-action';
import OtherForms from '../../../../modals/order-details-modal/order-details-modal-content/shipments/section-expander-and-actions/actions/documents/other-forms';
import { PackingSlip } from '../../../../../containers/print-document-button-containers/order-details/components/packing-slip';
import { PickList } from '../../../../../containers/print-document-button-containers/order-details/components/pick-list';
import { ShipmentManifest } from '../../../../../containers/print-document-button-containers/shipments-grid/components/shipment-manifest';
import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlan } from '../../../../../hooks/entities/selectors/fulfillment-plans';

import messages from '../messages';

const PrintShipmentMenuItem = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const fulfillmentPlan = useEntitiesFulfillmentPlan(fulfillmentPlanId);
  const fulfillmentPlanIds = [fulfillmentPlanId];
  const fulfillmentPlans = [fulfillmentPlan];
  const fulfillmentIds = fulfillmentPlan.fulfillmentIds;
  const fulfillments = useSelector((state) =>
    Global.selectEntitiesFulfillmentsByFulfillmentPlanId(state, {
      fulfillmentPlanId,
    }),
  );
  const trackPackingSlipClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.PRINT_PACKING_SLIPS);
  const { packingSlipTemplateId } = fulfillmentPlan;
  const userHasShippingRole = useSelector(Global.selectUserhasShippingRole);
  const trackLabelClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.PRINT_LABELS);
  const trackPickListClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.PRINT_PICK_LISTS);
  const trackCustomsFormClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.PRINT_CUSTOMS_FORMS);
  const trackShipmentManifestClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.PRINT_SHIPMENT_MANIFEST);
  const shipmentManifestData = buildShipmentManifestData(fulfillmentPlans);

  return (
    <DropdownMenuItemWithNestedMenu title={<FormattedMessage {...messages.printShipment} />}>
      <PackingSlip
        fulfillmentPlanIds={fulfillmentPlanIds}
        fulfillmentPlans={fulfillmentPlans}
        onClick={trackPackingSlipClicks}
        packingSlipTemplateId={packingSlipTemplateId}
      />
      <Label
        fulfillmentIds={fulfillmentIds}
        fulfillments={fulfillments}
        onClick={trackLabelClicks}
        userHasShippingRole={userHasShippingRole}
      />
      <PickList fulfillmentPlanIds={fulfillmentPlanIds} onClick={trackPickListClicks} />
      <CustomsForm fulfillmentIds={fulfillmentIds} fulfillmentPlanIds={fulfillmentPlanIds} onClick={trackCustomsFormClicks} />
      <ShipmentManifest selectedData={shipmentManifestData} trackOnClick={trackShipmentManifestClicks} />
      <OtherForms fulfillmentIds={fulfillmentIds} fulfillmentPlanIds={fulfillmentPlanIds} />
    </DropdownMenuItemWithNestedMenu>
  );
};

export default PrintShipmentMenuItem;
